<template>
    <div>
        <DialogoExito ref="refDialExito"></DialogoExito>
        <!-- 
            Dialogo que contiene los formularios de modificacion de datos y subsidios
            -->
        <v-dialog v-model="isActive" transition="dialog-bottom-transition" persistent fullscreen no-click-animation
            hide-overlay>
            <v-card flat>
                <v-app-bar class="rounded-0" height="60" color="white" flat>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon @click="cerrarDialogo">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title class="font-weight-bold primary--text">{{ titulo }}</v-toolbar-title>
                </v-app-bar>
                <v-card-title class="d-flex flex-row align-center">
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-alert colored-border color="orange darken-3" border="left" elevation="0" dense
                                class="px-10 my-0 rounded-0 font-weight-bold text-body-1 orange--text text--darken-3"
                                style="word-break: keep-all;">
                                Los datos aquí ingresados revisten carácter de declaración jurada.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <div v-if="type == 'otro'">
                        <FormDatosAfi class="mt-2" @datosGuardados="cambiarForm" />
                    </div>
                    <div v-if="type == 'modificacion'">
                        <v-stepper v-model="activeStep" flat>
                            <v-stepper-header class="elevation-0">
                                <v-stepper-step :complete="stepOneCompletado" step="1">
                                    DATOS PERSONALES
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step step="2" :rules="[() => (!this.activaBadge) || this.stepOneCompletado]">
                                    <v-badge v-if="activaBadge" :color="(!stepOneCompletado) ? 'orange darken-3' : ''"
                                        dot :class="(!stepOneCompletado) ? 'orange--text text--darken-3' : ''">
                                        DATOS FAMILIARES
                                    </v-badge>
                                    <template v-else>
                                        DATOS FAMILIARES
                                    </template>
                                </v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <!-- Paso 1: Datos personales -->
                                <v-stepper-content step="1">
                                    <FormDatosAfi :key="formDatosAfiKey" @siguiente="nextStep"
                                        @cambioEstadoCivil="activarBadge" @handleDialog="cerrarDialogo" />
                                </v-stepper-content>
                                <!-- Paso 2: Datos familiares -->
                                <v-stepper-content step="2">
                                    <FormEditarFam :key="formEditarFamKey" @volver="previousStep"
                                        @handleDialog="cerrarDialogo" />
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                        <!--  <v-tabs v-model="activeTab" background-color="transparent" height="45px">
                            <v-tab class="text-subtitle-1" :class="(!activeTab) ? 'font-weight-bold' : ''">
                                DATOS PERSONALES
                            </v-tab>
                            <v-tab class="text-subtitle-1" :class="(activeTab) ? 'font-weight-bold' : ''">
                                <v-badge v-if="activaBadge" color="orange darken-3" dot
                                    class="orange--text text--darken-3">
                                    DATOS FAMILIARES
                                </v-badge>
                                <span v-else>DATOS FAMILIARES</span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="activeTab">
                            <v-tab-item>
                                <FormDatosAfi class="mt-2" @datosGuardados="cambiarForm"
                                    @cambioEstadoCivil="activarBadge" />
                            </v-tab-item>
                            <v-tab-item>
                                <ListadoFamiliares v-if="!activaBadge" />
                                <FormEditarFam v-else></FormEditarFam>
                            </v-tab-item>
                        </v-tabs-items> -->
                    </div>
                    <div v-if="type == 'adopcion'">
                        <FormSubsidios @handleDialog="cerrarDialogo" />
                    </div>
                    <div v-if="type == 'maternidad' || type == 'madrenogestante'">
                        <FormSubsidioMaternidad @handleDialog="cerrarDialogo" />
                    </div>
                    <div v-if="type == 'matrimonio' || type == 'unionconvivencial'">
                        <!-- handleDialogo: cierra el dialogo que contiene el formulario -->
                        <!-- Mismo formulario Matrimonio/Union Convivencial -->
                        <FormSubsidioMatrimonio @handleDialog="cerrarDialogo" :tipo="type" />
                    </div>
                    <div v-if="type == 'nacimiento'">
                        <FormSubsidioNacimiento @handleDialog="cerrarDialogo" />
                    </div>
                    <div v-if="type == 'medioDePago'">
                        <FormMedioDePago @handleDialog="cerrarDialogo" />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

//componentes
import DatosAfiliacion from '@/components/forms/FormularioVista.vue'
import ExpansionPanelGen from '@/components/panels/ExpansionPanelGen.vue'
import FormPreContacto from '@/components/forms/FormPreContacto.vue'
import FormSubsidios from '@/components/forms/FormSubsidios.vue'
import FormSubsidioNacimiento from '@/components/forms/FormSubsidioNacimiento.vue'
import FormSubsidioMaternidad from '@/components/forms/FormSubsidioMaternidad.vue'
import FormSubsidioMatrimonio from '@/components/forms/FormSubsidioMatrimonio.vue'
import FormDatosAfi from '@/components/forms/FormDatosAfi.vue'
import FormEditarFamPlus from '@/components/forms/FormEditarFamPlus.vue'
import FormEditarFam from '@/components/forms/FormEditarFam.vue'
import ListadoFamiliares from '@/views/ListadoFamiliares.vue'
import DialogoExito from '@/components/dialogos/DialogoExito.vue'

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        ExpansionPanelGen,
        FormSubsidioMaternidad,
        ListadoFamiliares,
        FormSubsidioMatrimonio,
        FormSubsidioNacimiento,
        FormPreContacto,
        FormDatosAfi,
        FormSubsidios,
        DatosAfiliacion,
        DialogoExito,
        FormEditarFam,
        FormEditarFamPlus
    },
    mounted() {
    },
    data() {
        return {
            activeStep: 1,
            stepOneCompletado: false,
            objetoEstadoCivil: '',
            correct: false,
            activaBadge: false,
            isActive: false,
            subsidSuccess: false,
            activeTab: 0, // Índice de la pestaña activa
            formEditarFamKey: 0, // Key to force remount of FormEditarFam
            formDatosAfiKey: 0, // Key to force remount of FormDatosAfi
            //ultimo paso
            tipdoc: '1',
            // ExpansionPanel items datos personales
            // revisar op en los items

            itemsPersonales: [
                /*   { title: 'Mi información personal', icon: 'mdi-account-outline', color: 'primary', component: 'FormPreAfi' }, */
                {
                    title: 'DNI (frente y dorso)', icon: 'mdi-card-account-details-outline', color: 'primary', component: 'InputArchGen',
                    props: {
                        op: 'personales',
                        label: 'Seleccione la documentacion.',
                        rules: 'required|ext:jpg,pdf,jpeg|size:5000',
                    }
                },
                {
                    title: 'Foto carnet', icon: 'mdi-camera-outline', color: 'primary', component: 'FormPreFotoCarnet'
                },
            ],

            //ExpansionPanel items datos contactos

            itemsContactos: [
                { title: 'Contactos', icon: 'mdi-home-outline', color: 'primary', component: 'FormPreContacto' },
            ],

            //ExpansionPanel items datos profesionales 
            itemsProfesionales: [
                { title: 'Mis datos profesionales', icon: 'mdi-account-school-outline', color: 'primary', component: 'FormProfesionales' },
                {
                    title: 'Título profesional (Frente y dorso)', icon: 'mdi-certificate-outline', color: 'primary', component: 'InputArchGen',
                    props: {
                        op: 'profesionales1',
                        label: 'Si su título no tiene nro de matricula, deberá enviar certificado de matriculación ',
                        rules: 'required|ext:jpg,pdf,jpeg'
                    }
                },
                {
                    title: 'Certificado de matriculacion', icon: 'mdi-file-certificate-outline', color: 'primary', component: 'InputArchivos'
                    , props: {
                        op: 'profesionales2',
                        label: 'cambiar op y agregar la opcion del certificado',
                        rules: 'required|ext:jpg,pdf,jpeg'
                    },
                }
            ],

            //ExpansionPanel items opcion de nivel 
            itemsNivel: [
                { title: 'Video Informativo', icon: 'mdi-video-outline', color: 'primary', component: 'FormVideoNivel' },
                /*   { title: 'Opción de nivel', icon: 'mdi-account-star-outline', color: 'primary', component: 'FormNivel' }, */
            ],
        }
    },
    watch: {
        isActive(newVal) {
            if (newVal && this.type === 'modificacion') {
                // Cada vez que se abre el diálogo en modo modificación, remount ambos formularios
                this.formEditarFamKey++;
                this.formDatosAfiKey++;
            }
        },
        activeStep(newStep) {
            if (newStep === 2) {
                this.formEditarFamKey++; // Increment key to remount FormEditarFam
            }
        },
    },
    methods: {
        ...mapActions(['getFamiliar']),
        ...mapActions('stepper', ['nextStep', 'backStep', 'pasoValido']),
        ...mapActions('preafiliacion', ['crearFormData']),
        ...mapActions('auth', ['getUser']),

        abrirDialogo() {
            console.log("Abriendo diálogo...");
            this.isActive = true; // Cambia el estado para mostrar el diálogo
        },
        resetState() {
            // Restablece el estado interno del componente
            this.activeStep = 1; // Ejemplo: restablecer el paso activo
        },
        crearAfiliacion() {
            this.crearFormData()
        },
        nextStep() {
            this.activeStep++
            this.stepOneCompletado = true
        },
        previousStep() {
            this.activeStep--
            this.activaBadge = false
            this.stepOneCompletado = false
        },
        cerrarDialogo() {
            this.isActive = false
            let vm = this
            if (this.successSubsidio) {
                this.$refs.refDialExito.abrirDialog().then((result) => {
                    if (result) {
                        vm.$router.push('/tramites').catch(() => { })
                    } else {
                        vm.$router.push('/subsidios').catch(() => { })
                    }
                }
                )
            } else {
                //location.reload();
            }
        },
        activarBadge(value) {
            this.activaBadge = value
        },
        cambiarForm() {
            if (this.activeTab == 0) {
                this.activeTab = 1
            } else if (this.activeTab == 1)
                this.activeTab = 0

        },
        volver() {
            this.activeTab = 0
        },
        handleValidation(data) {
            //si los elementos del array son true
            if (data.every((index) => index == true)) {
                this.pasoValido(true)
            }
        },
        pushItems() {
            this.itemsProfesionales.push(
                {
                    title: 'Historial de matricula', icon: 'mdi-card-account-details-outline', color: 'primary', component: 'InputArchGen',
                    props: {
                        op: 'profesionales2',
                        label: 'Seleccione la documentacion.',
                        rules: 'required|ext:jpg,pdf,jpeg|size:5000',
                    }
                })
            //console.log(this.itemsProfesionales)
        },
        valFormContact(data) {
            //validacion formulario contacto, atenti 
            console.log('valFormContact')
            this.nextStep()
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['nuevoAfiliado']),
        ...mapGetters('subsidios', ['successSubsidio']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('stepper', ['e1', 'isValid']),
        ...mapGetters('familiar'),
    },
    props: {
        titulo: {
            type: String,
            required: true,

            // default: 'Preafiliacion'
        },
        type: {
            type: String,
            required: true,
            //default: 'modificacion'
        },
    }
    //props: ['titulo', 'type'],
}
</script>